import { render, staticRenderFns } from "./certsHandler.vue?vue&type=template&id=25c185e6&"
import script from "./certsHandler.vue?vue&type=script&lang=js&"
export * from "./certsHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports